import styled, { css } from "styled-components";
import React from "react";

interface IProps {
  percent: number;
}

export function ProgressBar({ percent }: IProps) {
  return (
    <ProgressViewStyled>
      <CurrentProgressViewStyled $percent={percent} />
    </ProgressViewStyled>
  );
}

const ProgressViewStyled = styled.div`
  border-radius: 0.4rem 0.4rem 0 0;
  height: 0.4rem;
  // todo: color
  background-color: #fafafa;
  overflow: hidden;
  position: relative;
  width: 100%;
`;

const CurrentProgressViewStyled = styled.div<{ $percent: number }>`
  ${({ theme, $percent }) => css`
    width: ${$percent}%;
    height: 0.4rem;
    border-radius: 0.4rem 0.4rem 0 0;
    background-color: ${theme.colors.primary_red};
    position: absolute;
    z-index: 1;
    transition: width 0.3s ease-out;
  `}
`;
